/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownRightIcon32Regular = forwardRef('ArrowDRadiusDownRightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M5 6c0 6.075 4.925 11 11 11h10.585l-7.292-7.293a1 1 0 0 1 1.414-1.414l7.338 7.338a3.35 3.35 0 0 1 0 4.738l-7.338 7.338a1 1 0 0 1-1.414-1.414L26.586 19H16C8.82 19 3 13.18 3 6V5a1 1 0 1 1 2 0v1Z" })));
});
